import React from "react";
import {thStyles} from "./tableStyles";
import ChangeHistoryRow from "./ChangeHistoryRow";

const LastDifferingRecommendation = (props) => (
    <div style={{marginBottom: "0px"}}>
        <h3 style={{color: "#28313E", margin: "20px 20px 0 20px", fontSize: "100%"}}>
            Last Differing Recommendation
        </h3>
        <div style={{padding: "20px", margin: "0 20px"}}>
            <table style={{width: "100%"}}>
                <thead>
                <tr>
                    <th style={thStyles}></th>
                    <th style={thStyles}></th>
                    <th style={thStyles}>Target Price</th>
                    <th style={thStyles}>Validity Period</th>
                </tr>
                </thead>
                <tbody>
                    <ChangeHistoryRow {...props.recommendation} />
                </tbody>
            </table>
        </div>
    </div>
);

LastDifferingRecommendation.propTypes = {
    recommendation: React.PropTypes.object.isRequired
};

export default LastDifferingRecommendation;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/LastDifferingRecommendation.js
 **/